import { render, staticRenderFns } from "./ExtraAward.vue?vue&type=template&id=358a2233&scoped=true"
import script from "./ExtraAward.vue?vue&type=script&lang=js"
export * from "./ExtraAward.vue?vue&type=script&lang=js"
import style0 from "./ExtraAward.vue?vue&type=style&index=0&id=358a2233&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358a2233",
  null
  
)

export default component.exports